export const init = () => {

  // TRACKER 'SUBSCRIPTION'
  const tracker = new AnalyticsTracker(AnalyticsConstants.trackers.customer.subscription);

  /*
	 * -- PERSONAL INFORMATION
	 */
  // changeSubscription
  const changeSubscription = new AnalyticsTriggerEvent('changeSubscription', tracker.defaultEvent());
  changeSubscription.trigger = 'change';
  changeSubscription.domElement = '.dkt-toggler input';
  changeSubscription.getLabel = $element => {
      const type = $element.data('type');
      return type.charAt(0) + type.slice(1).toLowerCase();
  };
  changeSubscription.getValue = $element => {
      return $element.val() === 'on' ? '1' : '0';
  };
  tracker.addEvent(changeSubscription);

  // confirmChange
  const confirmChangeSubscription = new AnalyticsClickEvent('confirmChangeSubscription', tracker.defaultEvent());
  confirmChangeSubscription.domElement = '#validate-button';
  confirmChangeSubscription.options.label = 'Confirm';
  tracker.addEvent(confirmChangeSubscription);

  // cancelChange
  const cancelChangeSubscription = new AnalyticsClickEvent('cancelChangeSubscription', tracker.defaultEvent());
  cancelChangeSubscription.domElement = '#cancel-button';
  cancelChangeSubscription.options.label = 'Cancel';
  tracker.addEvent(cancelChangeSubscription);

  CUBE.Analytics.trackers.add(tracker);
  CUBE.Analytics.trackers.init(tracker.params.name);

};



// WEBPACK FOOTER //
// ./src/analytics/trackers/customer/subscription-tracker.js